/**
 * Recetas canónicas Costal Campesino (A/B/C).
 * Solo SKUs en venta. Combo = lista de compra, no kit de bodega.
 * Fuente: Costal-Campesino/RECETAS_COMBOS.md
 */

export const COSTAL_RECIPES = [
  {
    id: 'a',
    letter: 'A',
    name: 'Agua de jamaica con crunch',
    kicker: 'Infusión de casa',
    lead: 'Jamaica para beber; girasol para picar.',
    method:
      '2 cdas de jamaica + 1 L de agua. Hervir, reposar 10 min, colar y enfriar. Endulzá en casa si hace falta. Crunch: un puñado de girasol.',
    pvp: '64,8 mil',
    accent: '#A0633A',
    skus: [
      { id: 28, name: 'Jamaica x500 g', price: '45,9 mil' },
      { id: 30, name: 'Girasol x500 g', price: '18,9 mil' },
    ],
  },
  {
    id: 'b',
    letter: 'B',
    name: 'Matcha de despensa',
    kicker: 'Ritual de taza',
    lead: 'Matcha en casa; almendra encima.',
    method:
      '1 cdita de matcha + 80 ml de agua a ~80 °C. Batir. Completar con leche o bebida vegetal de casa. Encima: almendra picada.',
    pvp: '101,8 mil',
    accent: '#4A5C3D',
    skus: [
      { id: 34, name: 'Matcha x125 g', price: '54,9 mil' },
      { id: 31, name: 'Almendra x500 g', price: '46,9 mil' },
    ],
  },
  {
    id: 'c',
    letter: 'C',
    name: 'Mix campesino',
    kicker: 'Semillas al sol',
    lead: 'Snack o topping. Lo que hay, mezclado.',
    method:
      '2 cdas de girasol + 1 cda de calabaza + macadamia al gusto. Mezclar. Solo, en ensalada o sobre yogurt.',
    pvp: '99,7 mil',
    accent: '#C4A574',
    skus: [
      { id: 30, name: 'Girasol x500 g', price: '18,9 mil' },
      { id: 29, name: 'Calabaza x500 g', price: '41,9 mil' },
      { id: 33, name: 'Macadamia', price: '38,9 mil' },
    ],
  },
];

export const COSTAL_COPY = {
  promise: 'En Costal Campesino no solo comprás el producto: comprás la receta.',
  tagline: 'Somos la tienda de tu receta.',
  kicker: 'Despensa honesta',
};

export const COSTAL_FEATURED_SKU_IDS = [28, 30, 34, 31, 29, 33, 102, 103];
